import { render, staticRenderFns } from "./privacyPolicy.vue?vue&type=template&id=6751b11c&"
import script from "./privacyPolicy.vue?vue&type=script&lang=js&"
export * from "./privacyPolicy.vue?vue&type=script&lang=js&"
import style0 from "./privacyPolicy.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports